import { Theme, ThemeOptions } from '@mui/material';

export const skeletonStyles = (theme: Theme): ThemeOptions => ({
  components: {
    MuiSkeleton: {
      defaultProps: {
        height: 28,
      },
      variants: [
        {
          props: { variant: 'rectangular' },
          style: {
            borderRadius: theme.shape.borderRadius,
          },
        },
      ],
    },
  },
});
